import './modal.scss'
import { register } from 'tmr/tmr/ngModuleRegistry'

import * as aboutModal from './aboutModal/aboutModal'
import * as copyToClipboardModal from './copyToClipboardModal/copyToClipboardModal'
import * as loginModal from './loginModal/loginModal'
import * as printModal from './printModal/printModal'
import * as printMultipleModal from './printMultipleModal/printMultipleModal'
import * as promptModal from './promptModal/promptModal'

export default register(
  'tmr.core.components.modals',
  aboutModal,
  copyToClipboardModal,
  loginModal,
  printModal,
  printMultipleModal,
  promptModal
)
